import React from 'react';
import { motion } from 'framer-motion';
import { Building2, AlertTriangle, CheckSquare, Info } from 'lucide-react';
const CARDS = [{
  icon: Building2,
  title: 'Broker Clearing Houses'
}, {
  icon: AlertTriangle,
  title: 'Carrier Identity Risk'
}, {
  icon: CheckSquare,
  title: 'Cleaner Setup'
}];
export function BrokerVerification() {
  return <section className="section-padding bg-white border-t border-steel" data-id="element-29">
      <div className="container-custom" data-id="element-30">
        <div className="grid lg:grid-cols-[1fr_minmax(360px,420px)] gap-10 lg:gap-14 items-center" data-id="element-31">
          {/* Left: heading, paragraph, cards, callout */}
          <div data-id="element-32">
            <div className="max-w-2xl mb-8" data-id="element-33">
              <h2 className="text-3xl md:text-4xl font-black text-navy mb-4 tracking-tight" data-id="element-34">
                Brokers Are Verifying Carriers Harder Than Ever
              </h2>
              <p className="text-lg text-body font-medium leading-relaxed" data-id="element-35">
                Carrier identity theft, fraud checks, broker portals, and
                clearing house requirements are making setup harder. FSG helps
                carriers look organized, verifiable, and ready to work with
                better brokers.
              </p>
            </div>

            <div className="grid sm:grid-cols-3 gap-6 mb-8" data-id="element-36">
              {CARDS.map((card, i) => <motion.div key={i} initial={{
              y: 20
            }} whileInView={{
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: i * 0.1
            }} className="bg-off-white border border-steel rounded-sm p-6 flex items-center gap-4 h-full" data-id="element-37">
                  <card.icon className="w-6 h-6 text-red shrink-0" data-id="element-38" />
                  <span className="font-bold text-navy" data-id="element-39">{card.title}</span>
                </motion.div>)}
            </div>

            <div className="flex items-start gap-3 bg-navy/5 border border-navy/10 rounded-sm p-5" data-id="element-40">
              <Info className="w-5 h-5 text-navy shrink-0 mt-0.5" data-id="element-41" />
              <p className="text-body font-medium" data-id="element-42">
                <span className="font-bold text-navy" data-id="element-43">Plain English:</span> FSG
                helps carriers look organized and verifiable when brokers set up
                accounts and load paperwork.
              </p>
            </div>
          </div>

          {/* Right: supporting visual */}
          <div className="hidden md:flex justify-center lg:justify-end" data-id="element-44">
            <img src="https://cdn.magicpatterns.com/uploads/u6Taiv69AzSm517ARxv5F2/fsg-broker-security-visual.svg" alt="Broker verification and carrier security support illustration" className="w-full max-w-[420px] h-auto" data-id="element-45" />
          </div>
        </div>
      </div>
    </section>;
}